import type { ApiClient } from '../client.js'
import type {
  CreateDictionaryRequest,
  DictionaryDetail,
  DictionaryEntry,
  DictionarySummary,
  UpdateDictionaryRequest,
  UpsertDictionaryEntryRequest,
} from '../types/dictionary.js'

export function listDictionaries(client: ApiClient): Promise<DictionarySummary[]> {
  return client.request<DictionarySummary[]>('/api/v1/dictionaries')
}

export function getDictionary(client: ApiClient, dictionaryId: number): Promise<DictionaryDetail> {
  return client.request<DictionaryDetail>(`/api/v1/dictionaries/${dictionaryId}`)
}

export function createDictionary(
  client: ApiClient,
  data: CreateDictionaryRequest
): Promise<DictionarySummary> {
  return client.request<DictionarySummary>('/api/v1/dictionaries', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export function updateDictionary(
  client: ApiClient,
  dictionaryId: number,
  data: UpdateDictionaryRequest
): Promise<DictionarySummary> {
  return client.request<DictionarySummary>(`/api/v1/dictionaries/${dictionaryId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}

export function deleteDictionary(client: ApiClient, dictionaryId: number): Promise<void> {
  return client.request<void>(`/api/v1/dictionaries/${dictionaryId}`, {
    method: 'DELETE',
  })
}

export function createDictionaryEntry(
  client: ApiClient,
  dictionaryId: number,
  data: UpsertDictionaryEntryRequest
): Promise<DictionaryEntry> {
  return client.request<DictionaryEntry>(`/api/v1/dictionaries/${dictionaryId}/entries`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export function updateDictionaryEntry(
  client: ApiClient,
  dictionaryId: number,
  entryId: number,
  data: UpsertDictionaryEntryRequest
): Promise<DictionaryEntry> {
  return client.request<DictionaryEntry>(`/api/v1/dictionaries/${dictionaryId}/entries/${entryId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}

export function deleteDictionaryEntry(
  client: ApiClient,
  dictionaryId: number,
  entryId: number
): Promise<void> {
  return client.request<void>(`/api/v1/dictionaries/${dictionaryId}/entries/${entryId}`, {
    method: 'DELETE',
  })
}
